import 'mf-ui-components/assets/AssetLoader.js';
import { SpriteSheetLoader } from './SVGSpritesheetLoader';
export const initUiLibrary = () => {
    new SpriteSheetLoader().load(window._ASSETS.flags);
    new SpriteSheetLoader().load(window._ASSETS.icons);
};
//# sourceMappingURL=initUiLibrary.js.map